<template>
  <footer class="appfooter">
    <a href="https://www.studiokromhout.nl" target="_blank" class="webLink"
      >Studio Kromhout &copy; 2024 |
      <span id="version">{{ version }}</span>
    </a>
  </footer>
</template>
<script setup>
defineOptions({
  name: 'FooterElement'
});
const version = import.meta.env.PACKAGE_VERSION;
</script>
<style>
.appfooter {
  background-color: white;
  width: 100%;
  height: calc(1 * var(--button-size));
}

.webLink {
  color: var(--dark-gray);
  line-height: calc(1 * var(--button-size));
  font-size: calc(0.3 * var(--button-size));
  margin: calc(0.4 * var(--button-size));
  height: calc(1 * var(--button-size));
  cursor: pointer;
  float: left;
  text-decoration: none;
}
</style>
